import { textColor } from './color';
export default {
  textStyle: {
    color: textColor.normal
  },
  subtextStyle: {
    color: textColor.gray
  }
};